import { Component, computed, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef } from '@angular/core';
import { AuthService } from '@/core/auth.service';
import { AuthStore } from '@/core/auth.store';

@Component({
  selector: 'mobile-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './mobile-layout.html',
})
export class MobileLayout {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private readonly authService = inject(AuthService);
  private readonly authStore = inject(AuthStore);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly userName = computed(() => this.authStore.user()?.name ?? '');
  protected readonly title = signal(this.deepestChildTitle());
  protected readonly showBack = signal(this.router.url !== '/mobile');

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.title.set(this.deepestChildTitle());
        this.showBack.set(this.router.url !== '/mobile');
      });
  }

  private deepestChildTitle(): string {
    let route = this.route.firstChild;
    while (route?.firstChild) route = route.firstChild;
    return route?.snapshot?.data?.['title'] ?? '';
  }

  protected goBack(): void {
    this.location.back();
  }

  protected onLogout(): void {
    this.authService.logout().subscribe({
      next: () => this.router.navigateByUrl('/auth/login'),
      error: () => {
        this.authStore.clear();
        this.router.navigateByUrl('/auth/login');
      }
    });
  }
}
